<template>
  <div class="d-flex flex-column flex-fill">
    <div class="d-flex text-left flex-column border-bottom p-3">
      <span>商品標題：</span>
      <div v-for="(item, index) in iconNum.length" :key="index"
        class="d-flex flex-fill align-items-center justify-content-start">
        <div class="d-flex flex-column align-items-center border m-3">
          <span>【ICON圖示】</span>
          <div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" value id="designCheck" />
              <label class="form-check-label" for="designCheck">上線</label>
            </div>
          </div>
          <div class="d-flex align-items-center">
            <div>
              <label for="designInput">小標題</label>
            </div>
            <div style="width:100px;">
              <b-form-input id="designInput"></b-form-input>
            </div>
          </div>
          <div style="width:200px;">
            <b-form-file placeholder="上傳圖示"></b-form-file>
          </div>
        </div>
        <div v-if="index === (iconNum.length - 1)">
          <button type="button" class="btn btn-outline-secondary" @click="addiconNum()">新增</button>
        </div>
        <div v-if="index !== (iconNum.length - 1)">
          <button type="button" class="btn btn-outline-secondary"
            @click="lessiconNum(index)">刪除</button>
        </div>
      </div>
      <span>【HTML介紹列表】</span>
      <div>
        <table class="htmllist table table-bordered">
          <thead>
            <tr>
              <th>上線</th>
              <th>次標題</th>
              <th>內容</th>
              <th>排序</th>
            </tr>
          </thead>
          <tbody align="center">
            <tr v-for="(item, index) in 2" :key="index">
              <td>
                <b-form-checkbox value="accepted" unchecked-value="not_accepted">
                </b-form-checkbox>
              </td>
              <td>
                <b-input></b-input>
              </td>
              <td>
                <ckeditor :editor="editor" v-model="editorData" :config="editorConfig"></ckeditor>
              </td>
              <td>
                <div class="d-flex flex-column">
                  <a href="#" @click.prevent>上移</a>
                  <a href="#" @click.prevent>下移</a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="d-flex text-left flex-column border-bottom p-3">
      <span>【收據列印】</span>
      <span>電子／實體課程備註</span>
      <div>
        <b-form-textarea id="textarea" rows="3" max-rows="6">
        </b-form-textarea>
      </div>
    </div>
    <div class="d-flex text-left flex-column border-bottom p-3">
      <span>【網頁設定】</span>
      <span class="pt-3">關鍵字、網頁描述、JS外掛程式碼</span>
      <div class="pt-3">
        <b-form-textarea id="textarea" placeholder="關鍵字" rows="3" max-rows="6">
        </b-form-textarea>
      </div>
      <div class="pt-3">
        <b-form-textarea id="textarea" placeholder="網頁描述" rows="3" max-rows="6">
        </b-form-textarea>
      </div>
      <div class="pt-3">
        <b-form-textarea id="textarea" placeholder="JS外掛程式碼" rows="3" max-rows="6">
        </b-form-textarea>
      </div>
    </div>
  </div>
  <!-- <div class="d-flex justify-content-center">
    <div class="Other d-flex flex-column">
      <div class="d-flex flex-row h-100 border">
        <div class="d-flex border-right align-items-center tableTitle">後台備註</div>
        <div class="d-flex flex-column flex-fill align-items-start">
          <b-form-textarea style="width:400px"></b-form-textarea>
          <small>( 100 字 消費者看不到 )</small>
          <b-form-checkbox :value="true" :unchecked-value="false" v-model="backstagePs"
            >訂單產生時，將此備註文字寫入到訂單細目的[後台備註]中</b-form-checkbox
          >
        </div>
      </div>
      <div class="d-flex flex-row h-100 border">
        <div class="d-flex border-right align-items-center tableTitle">關鍵字</div>
        <div class="d-flex flex-column flex-fill align-items-start text-left">
          <b-form-textarea style="width:400px"></b-form-textarea>
          <small>( 80 字 )</small>
          <div>
            <ul>
              <li>輸入該商品可被搜尋到的額外的關鍵字 ( 每個關鍵字間請使用逗號分開 )</li>
              <li>讓 Yahoo 、 Google 或 SHOP2000商品中心 可以更容易找到本商品</li>
              <li>
                若商品名稱內已經含有有該關鍵字則不須輸入於此欄位中 ( 系統已會自動將商品名稱加入 )
              </li>
              <li>
                關鍵字訣竅1：輸入字數越少分數越高，建議字數5~20字內，例如只輸入『女裝』會比輸入『女裝,洋裝,短裙』分數高
              </li>
              <li>
                關鍵字訣竅2：關聯性越高則分數越高，例如輸入『女裝,洋裝,短裙』會比輸入『女裝,汽車,寵物』分數高
              </li>
              <li>關鍵字訣竅3：網頁內文中若含有上面您設定的關鍵字，則會加分</li>
              <li>分數越高排序愈前面</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="d-flex flex-row h-100 border">
        <div class="d-flex border-right align-items-center tableTitle">javascript程式碼</div>
        <div class="d-flex flex-column flex-fill align-items-start text-left">
          <b-form-textarea style="width:700px" rows="20"></b-form-textarea>
          <small>( 2000 字 )</small>
          <div>
            <ul>
              <li>於本商品網頁中崁入javascript程式碼，如：Google analytics 流量分析、FaceBook像素追蹤..等，或自行撰寫</li>
              <li>您的javascript程式碼若沒寫好將會造成網頁掛掉</li>
              <li>本程式碼會崁入於您網站內每個網頁的 ＜HEAD＞ 區段內</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div> -->
</template>
<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import '@ckeditor/ckeditor5-build-classic/build/translations/zh';

export default {
  data() {
    return {
      iconNum: [''],
      backstagePs: '',
      editor: ClassicEditor,
      editorData: '<p></p>',
      editorConfig: {
        language: 'zh',
      },
    };
  },
  methods: {
    addiconNum() {
      if (this.iconNum.length < 3) {
        this.iconNum.push('');
      }
    },
    lessiconNum(index) {
      this.iconNum.splice(index, 1);
    },
  },
};

</script>
<style lang="scss">
  .ck-editor__editable {
    max-height: 100px !important;
  }
  .htmllist{
    td{
      vertical-align: middle;
    }
  }

</style>
